import { hasCapability, type User } from "../base";
import { bidWhereUnique } from "./bid";
import { projectWhere } from "./project";

export const worksite = {
  read: (user: User) => hasCapability(user, "worksite.read"),
  accountManager: {
    transfer: (user: User) => hasCapability(user, "worksite.accountManager.transfer"),
  },
  address: {
    overridePhaseGate: (user: User) => hasCapability(user, "worksite.address.overridePhaseGate"),
  },
};

export const workSiteWhere = (user: User) => {
  if (hasCapability(user, "bid.read.all")) {
    return {};
  }
  return { OR: [{ bids: { some: bidWhereUnique(user) } }, { projects: { some: projectWhere(user) } }] };
};
